import { StringKeyOf } from 'ia-react-core/~/interfaces/StringKeyOf';
import keys from '../accessors/keys';

export default function filterKnownProps<
  Props extends Record<string, unknown>,
  Key extends StringKeyOf<Props>
>(props: Props, knownProps: Key[]) {
  return keys(props).reduce((result, propName) => {
    if (typeof propName === 'string' && !knownProps.includes(propName as Key)) {
      result[propName as Key] = props[propName as Key];
    }

    return result;
  }, {} as Pick<Props, Key>);
}
